import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
    requestCertificatesSuccess, requestDeleteCertificateFailed,
    requestDeleteCertificateSuccess
} from '../../actions/resources/Certificate';
import CertificateAPI from '../../api/resources/Certificate';
import ManageResource from '../../api/resources/ManageResource';
import * as Constants from '../../constants/resources';


function* getDeleteCertificate(data: any) {
    try {
        const response = yield call(
            ManageResource.DeleteCertificate,
            data.payload.certificate
        );
        const certificates = yield call(CertificateAPI.getCertificates);
        yield put(requestCertificatesSuccess(certificates));
        yield put(requestDeleteCertificateSuccess(response));
    } catch (error) {
        yield put(requestDeleteCertificateFailed(error));
    }
}

function* watchForDeleteCertificate() {
  yield takeLatest(Constants.DELETE_CERTIFICATE, getDeleteCertificate);
}

export default function* deleteCertificateSaga() {
  yield all([watchForDeleteCertificate()]);
}
